import React, { useRef } from 'react';

import ScrollingSideNav, { NavItem } from '@components/ScrollingSideNav';
import useScrollerPosition from '@hooks/useScrollerPosition';

export enum NavOption {
  EmailNotifications = 'email-notifications',
  ResearchHistory = 'research-history',
  Help = 'help',
}

export const NAV_OPTIONS: NavItem[] = [
  { id: NavOption.EmailNotifications, name: 'Email notifications' },
  { id: NavOption.ResearchHistory, name: 'Research history' },
  { id: NavOption.Help, name: 'Help' },
];

const Nav = () => {
  const navRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const { activeSection, scrollerPosition, scrollToSection } = useScrollerPosition({
    navRef,
    scrollerRef,
  });

  return (
    <ScrollingSideNav
      navOptions={NAV_OPTIONS}
      activeSection={activeSection}
      scrollerPosition={scrollerPosition}
      scrollToSection={scrollToSection}
    />
  );
};

export default Nav;
